// =============================================================================
// StaticAppointmentBlock - Versione statica per DragOverlay
// =============================================================================

import { parseISO } from 'date-fns';
import { useTenantTimeZone } from '../../../store/tenantStore';
import { timeStringInTz } from '../../../lib/tenantTime';
import { Users } from 'lucide-react';
import { getServiceColor, getContrastTextColor, lightenColor } from '../utils/color.utils';
import { ROW_HEIGHT } from '../utils/grid.constants';
import type { StaticAppointmentBlockProps } from '../types/scheduler.types';

export function StaticAppointmentBlock({ appointment, rect }: StaticAppointmentBlockProps) {
  const timeZone = useTenantTimeZone();
  const start = parseISO(appointment.scheduledStart);
  const serviceColor = getServiceColor(appointment.serviceDefinitionId, appointment.serviceColor);
  const bgColor = lightenColor(serviceColor, 0.75);
  const textColor = getContrastTextColor(bgColor);
  const displayName = appointment.customerName 
    ? appointment.customerName.split(' ').slice(-1)[0] 
    : '(Interno)';
  
  return (
    <div
      className="relative rounded-md px-2 py-1 overflow-hidden border-l-4 shadow-2xl ring-2 ring-blue-500 opacity-90 cursor-grabbing"
      style={{ 
        width: rect ? `${rect.width}px` : '180px',
        height: rect ? `${rect.height}px` : `${ROW_HEIGHT - 8}px`,
        backgroundColor: bgColor,
        borderLeftColor: serviceColor,
        boxSizing: 'border-box',
        margin: 0,
      }}
    >
      {/* Badge occupazione eventi di gruppo (x/max) */}
      {(appointment.maxClients ?? 1) > 1 && (
        <div
          className="absolute bottom-0.5 right-1 flex items-center gap-0.5 text-[10px] font-semibold opacity-90"
          style={{ color: textColor }}
        >
          <Users className="w-3 h-3" />
          {appointment.participantCount ?? 1}/{appointment.maxClients}
        </div>
      )}
      <div className="text-xs font-semibold truncate pr-4" style={{ color: textColor }}>
        {timeStringInTz(start, timeZone)} - {displayName}
      </div>
      <div className="text-xs truncate opacity-80" style={{ color: textColor }}>
        {appointment.serviceName}
      </div>
    </div>
  );
}
